export default __webpack_public_path__ + "static/media/automateAnything.24000cd2.png";